import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MuscleVolumeEntry } from 'services/workout-loader.service';

import { LL } from 'i18n/i18n.service';
@Component({
  selector: 'cs-muscle-volume',
  templateUrl: 'cs-muscle-volume.html',
  host: { 'class': 'muscle-volume' },
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsMuscleVolumeComponent {
  protected LL = LL;
  @Input() lowerBodyMuscles: MuscleVolumeEntry[] = [];
  @Input() upperBodyMuscles: MuscleVolumeEntry[] = [];
  /** When set, shows "before → after" format for changed muscles */
  @Input() beforeVolumes: { [muscleName: string]: number } | undefined;
}
